function calculateThumbnailsVisibility() {
    if (window.innerWidth < 1024) {
        const viewMoreButton = document.getElementById('view-more-button');
        viewMoreButton.style.display = 'none';
        return
    }

    const container = document.querySelector('.labyrinth-showcase__thumbnails');
    const thumbnailsList = document.getElementById('labyrinth-thumbnails');
    if (!container || !thumbnailsList) return;

    const viewMoreBtn = container.querySelector('.labyrinth-showcase__view-more');
    const btnHeight = viewMoreBtn ? viewMoreBtn.offsetHeight : 0;

    const gapStr = getComputedStyle(thumbnailsList).getPropertyValue('gap').trim();
    const gapValue = parseFloat(gapStr);

    const availableHeight = container.offsetHeight - btnHeight;

    // Filter only thumbnail card nodes
    const thumbnailNodes = Array.from(thumbnailsList.children).filter(node =>
        node.classList.contains('labyrinth-showcase__thumbnails-image')
    );

    // Measure the first card only (assume all same height)
    let cardHeight = 0;
    if (thumbnailNodes.length > 0) {
        // Make sure one is visible for correct measurement
        thumbnailNodes[0].style.display = '';
        cardHeight = thumbnailNodes[0].offsetHeight + gapValue;
    }

    // How many fit?
    const maxVisible = cardHeight > 0 ? Math.floor(availableHeight / cardHeight) : thumbnailNodes.length;

    // Only show those that fit
    thumbnailNodes.forEach((node, i) => {
        node.style.display = i < maxVisible ? '' : 'none';
    });

    // Show "View More" if some were hidden
    const overflow = maxVisible < thumbnailNodes.length;
    if (viewMoreBtn) viewMoreBtn.style.display = overflow ? 'block' : 'none';
}

// Debounced event handlers
function debounce(func, delay) {
    let timer;
    return function () {
        clearTimeout(timer);
        timer = setTimeout(func, delay);
    }
}

window.addEventListener('resize', debounce(calculateThumbnailsVisibility, 200));
window.addEventListener('load', calculateThumbnailsVisibility);


/**
 * Labyrinth Blog Post Component
 * Handles image switching and metadata updates for digital archive posts
 * @typedef {import('./global.d.ts')}
 */

if (!customElements.get('labyrinth-showcase-component')) {
    class LabyrinthBlogPostComponent extends HTMLElement {
        constructor() {
            super();
            /** @type {HTMLImageElement | null} */
            this.mainImage = null;
            /** @type {NodeListOf<HTMLButtonElement> | null} */
            this.thumbnails = null;
            /** @type {HTMLElement | null} */
            this.itemValue = null;
            /** @type {HTMLElement | null} */
            this.nameValue = null;
            /** @type {number} */
            this.currentIndex = 0;
            /** @type {boolean} */
            this.isTransitioning = false;
            /** @type {number | null} */
            this.pendingImageUpdate = null;
        }

        connectedCallback() {
            // Get DOM elements
            this.mainImage = this.querySelector('.labyrinth-showcase__image');
            this.thumbnails = this.querySelectorAll('.labyrinth-showcase__thumbnails-image');

            if (!this.thumbnails || this.thumbnails.length === 0) return;

            this.setupEventListeners();
        }

        setupEventListeners() {
            if (!this.thumbnails) return;

            // Thumbnail click handlers
            this.thumbnails.forEach((thumbnail, index) => {
                thumbnail.addEventListener('click', () => {
                    this.switchToImage(thumbnail, index);
                });
            });
        }

        /**
         * @param {HTMLButtonElement} thumbnail
         * @param {number} index
         */
        switchToImage(thumbnail, index) {
            if (!this.mainImage || !this.thumbnails) return;
            if (index === this.currentIndex) return;


            const image = thumbnail.querySelector('.image-block__image');

            // Get image and metadata from thumbnail
            const imageUrl = image?.getAttribute('src');
            const imageAlt = image?.getAttribute('alt');
            const imageSrcset = image?.getAttribute('srcset');

            if (!imageUrl) return;

            if (!this.mainImage) return;

            // Cancel any pending update
            if (this.pendingImageUpdate) {
                clearTimeout(this.pendingImageUpdate);
            }

            // Only add fade-out if not already transitioning
            if (!this.isTransitioning) {
                this.mainImage.classList.add('fade-out');
                this.isTransitioning = true;
            }

            this.pendingImageUpdate = setTimeout(() => {
                const img = this.mainImage;
                if (!img) return;

                // Clear any existing onload handler
                img.onload = null;

                img.onload = () => {
                    img.classList.remove('fade-out');
                    this.isTransitioning = false;
                    img.onload = null;
                };

                img.src = imageUrl;
                img.alt = imageAlt || '';
                if (imageSrcset) {
                    img.srcset = imageSrcset;
                }

                this.pendingImageUpdate = null;
            }, 250);


            // Update thumbnail states
            const currentThumbnail = this.thumbnails[this.currentIndex]?.querySelector('.image-block__image');
            if (currentThumbnail) {
                currentThumbnail.classList.remove('labyrinth-showcase__thumbnail--active');
                currentThumbnail.setAttribute('aria-selected', 'false');
            }

            image?.classList.add('labyrinth-showcase__thumbnail--active');
            image?.setAttribute('aria-selected', 'true');

            this.currentIndex = index;
        }
    }

    customElements.define('labyrinth-showcase-component', LabyrinthBlogPostComponent);
}

